import React from 'react'
import { StepId, StepsMeta } from '@/config/navigation.config'

export type StepContextT = {
  viewed: boolean
  restart: boolean | Date
  currentStepIndex: number
  /**
   * False while the URL has moved to another step but the step state hasn't caught up yet, so the
   * previous step still owns the shared action button
   */
  isStepSynced: boolean

  goForward: () => void
  goBack: () => void
  goToStep: (stepId: StepId) => void
  returnToPreviousStep: () => void
  handleRestart: () => Promise<void>
  setViewed: (nextValue: boolean) => void
  resetRestart: () => void
  setIsDirty: (dirty: boolean) => void
  isCurrentStepGreaterThan: (stepId: StepId) => boolean
  isCurrentStepEqualTo: (stepId: StepId) => boolean
  getStepsMetaForId: (id: StepId) => Nullable<StepsMeta>
  getIndexForId: (id: StepId) => number
  isStepUnlocked: (id: StepId) => boolean
}

export const defaultStepContext: StepContextT = {
  viewed: false,
  restart: false,
  currentStepIndex: 0,
  // outside the step flow there's no route change to wait for
  isStepSynced: true,

  // Functions
  goForward: () => { /* empty */ },
  goBack: () => { /* empty */ },
  goToStep: () => { /* empty */ },
  returnToPreviousStep: () => { /* empty */ },
  handleRestart: async () => { /* empty */ },
  setViewed: () => { /* empty */ },
  resetRestart: () => { /* empty */ },
  setIsDirty: () => { /* empty */ },
  isCurrentStepGreaterThan: () => false,
  isCurrentStepEqualTo: () => false,
  getStepsMetaForId: () => null,
  getIndexForId: () => -1,
  isStepUnlocked: () => false,
}

export const StepContext = React.createContext<StepContextT>(defaultStepContext)

export default StepContext
